// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_scrollable_body-module__container--3OETi"};